import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'
import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'

const DEFAULT_STATE = {
  loading: false,

  items: [],
  page: 1,
  limit: 20,
  total: 0,
  totalAll: 0,
  search: null,

  sort: {
    sort_by: SORT_ORDER.CREATED_AT,
    sort_direction: SORT_DIRECTION.DESC,
  },
}

export default {
  ...DEFAULT_STATE,
}
